import { render, staticRenderFns } from "./akcd_rules.vue?vue&type=template&id=5f022781&scoped=true"
import script from "./akcd_rules.vue?vue&type=script&lang=js"
export * from "./akcd_rules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f022781",
  null
  
)

export default component.exports